import { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { PlusIcon } from "lucide-react";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../component/table/table-layout";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import Tooltip from "../../../../component/ui/tooltip";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import VanDamageModal from "../../../../component/popup/add-update-van-damage";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import { TitleHeading } from "../../../../component/ui/layout";
import { CategoryIcon, DateIcon, MonthIcon, VanIcon } from "../../../../component/icons/filter-icons";

const VanDamageList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [tableHeaders, setTableHeaders] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [cars, setCars] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [showModal , setShowModal] = useState(false);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
    getVendors();
  }, []);

  const getData = async ({ filter = filterReturn, page = "" }) => {
    if (!page) {
      setIsLoading(true);
    }
    let extraUrl = `?page=${page}`;
    for (let i = 0; i < filter?.length; i++) {
      if (filter[i]?.selectedOpt == "between") {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value[0]}_${filter[i]?.value[1]}`;
      } else {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
      }
    }
    try {
      const res = await apiCall({
        method: "get",
        url: `get-van-damage-record-list${extraUrl}`,
        // url: "get-car-damage-record-list?incident_month=03-2025"
      });
      if (page) {
        setList((prev) => [...prev, ...res.vanDamageRecords
]);
      } else {
        setList(res.vanDamageRecords
);
      }
      setTableHeaders(res?.headers);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const getVendors = async () => {
    try {
      let apiResCar = await apiCall({
        method: "get",
        url: "get-fleet-car-van-dropdown?search_by_key_dd=allFleetVan",
      });
      setCars(apiResCar?.getFleetCarVanDropdown);
    } catch (error) {
      console.log("Error", error);
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    getData({});
    setCurrentData({});
    setAddModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const filterModalData = [
    {
      name: "incident_month",
      label: "Month",
      options: ["is", "between"],
      selectedOpt: "is",
      value: "",
      type: "month",
      betweenType: "month",
      Icon: MonthIcon
    },
    {
      name: "incident_date",
      label: "Date",
      options: ["is", "between"],
      selectedOpt: "is",
      value: "",
      type: "date",
      betweenType: "date",
      Icon: DateIcon
    },
    {
      name: "incident_type",
      label: "Incident Type",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [{label: "Accident", val: "Accident"}, {label: "Damage", val: "Damage"}, {label: "Theft", val: "Theft"}],
      dropdownKey: "label",
      dropdownVal: "val",
      Icon: CategoryIcon
    },
    {
      name: "van_id",
      label: "Van",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: cars,
      dropdownKey: "name",
      dropdownVal: "id",
      Icon: VanIcon
    }
  ];

  const editDetail = (ele) => {
    setCurrentData(ele);
    setAddModal(true);
  };

  const tableRef = useRef(null);

  return (
    <>
      <div className={Style.leaveMainPage}>
        <div className={Style.report_table__header}>
          <TitleHeading title={`Van Damage List`} />

          <div className={Style.bpfl_action}>
              <div
              className={Style.bpfl_action}
              onClick={() => {
                setAddModal(true);
              }}
            >
              <Tooltip
                content={"Add Record"}
                position={"left center"}
                className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
              >
                <div className={Style.icon}>
                   <PlusIcon size={'1em'} />
                </div>
              </Tooltip>
            </div>
            <Tooltip
              className={Style.bpfl_actionItems}
              content={"Table Filter"}
              position={"left center"}
            >
              <div
                className={`${Style.bpfl_actionBtn} ${
                  filterReturn?.length ? Style.active : null
                }`}
                onClick={() => {
                  setShowModalFilterTable(true);
                }}
              >
                <div className={Style.icon}>
                  <FilterFunnel01Icon />
                </div>
              </div>
            </Tooltip>
            <div className={`${Style.bpfl_action}`}>
              <Tooltip
                className={`${Style.bpfl_actionItems}`}
                content={"Customize Table"}
                position={"left center"}
              >
                <div
                  className={`${Style.bpfl_actionBtn}`}
                  onClick={() => {
                    setShowModalCustomizeTabs(true);
                  }}
                >
                  <div className={Style.icon}>
                    <LayoutTopIcon />
                  </div>
                </div>
              </Tooltip>
            </div>
          
          </div>
        </div>

        <div className={Style.LeaveBody}>
          {isLoading ? (
            <InnerLoader />
          ) : !lists?.length ? (
            <DataNotFound title={"lists"} />
          ) : (
            <>
              <TableCard ref={tableRef}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell header sticky>
                        <div className="flex gap-4 items-center">
                          <span>Name</span>
                        </div>
                      </TableCell>
                      {tableHeaders?.map((eachHead, index) =>
                        eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                          <TableCell header key={index}>
                            <TableHeaderWrap>
                              <span>{eachHead?.value}</span>
                            </TableHeaderWrap>
                          </TableCell>
                        ) : null
                      )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {lists?.map((eachList, index) => {
                      return (
                        <TableRow key={`${index}`}>
                          <TableCell sticky>
                            <div className={`${Style.tableActionArea} !gap-4`}>
                              {/* <div className="flex items-center gap-1">
                                <div
                                  className={Style.btn}
                                  onClick={() => {
                                    editDetail(eachList);
                                  }}
                                >
                                  <div
                                    className={Style.icon}
                                    style={{ color: "#d97706" }}
                                  >
                                    <Pencil className="h-4.5 w-4.5" />
                                  </div>
                                </div>
                              </div> */}
                              <div className="flex items-center gap-3">
                                {eachList?.car?.car_image ? (
                                  <img
                                    className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center"
                                    src={eachList?.car?.car_image}
                                    alt={eachList?.van_entitlement}
                                  />
                                ) : (
                                  <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                    {eachList?.van_entitlement?.split(" ")[0]
                                      ? eachList?.van_entitlement?.split(" ")[0][0]
                                      : ""}
                                    {eachList?.van_entitlement?.split(" ")[1]
                                      ? eachList?.van_entitlement?.split(" ")[1][0]
                                      : ""}
                                  </div>
                                )}
                                <div>
                                  <div className="font-medium leading-5">
                                    {eachList?.van_entitlement}
                                  </div>
                                  {/* <div className="text-xs text-muted-foreground">{eachList?.registration_number} • {eachList?.route}</div> */}
                                </div>
                              </div>

                              <div className={Style.tableActionAreaBtnGrpup}>
                                                              <div
                                                                className={
                                                                  "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                                                }
                                                                  onClick={() => {
                                    editDetail(eachList);
                                  }}
                                                              >
                                                                <div
                                                                  className={Style.icon}
                                                                  style={{ color: "#FF9500" }}
                                                                >
                                                                  <NewEditIcon className="h-4.5 w-4.5" />
                                                                </div>
                                                              </div>
                              
                                                             
                            
                                                            </div>
                            </div>
                          </TableCell>
                          {tableHeaders?.map((eachHead, i) => (eachHead.is_visible === 1 && eachHead?.show == 1) ? (
                              <TableCell key={`${i}-${index}`}>{eachList[eachHead?.key] ?? "-"}</TableCell>
                            ) : null)}

                          {/* {tableHeaders?.map((eachHead, i) => {
                            if (
                              eachHead.is_visible !== 1 ||
                              eachHead?.show !== 1
                            )
                              return null;

                            const cellValue = eachList[eachHead?.key];

                            return (
                              <TableCell key={`${i}-${index}`}>
                                {eachHead.key === "invoice_file_path" ? (
                                  cellValue ? (
                                    <a
                                      href={cellValue}
                                      target="_blank"
                                      className="underline decoration-solid hover:text-sky-800"
                                    >
                                      View Invoice
                                    </a>
                                  ) : (
                                    "-"
                                  )
                                ) : (
                                  cellValue ?? "-"
                                )}
                              </TableCell>
                            );
                          })} */}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableCard>
            </>
          )}
        </div>

        {!isLoading ? (
          <div className={Style.table_footer} style={{ alignItems: "center" }}>
            <div className={Style.table_footer_left}>
              {`showing 1 to ${lists?.length} of ${
                tablePagination?.total || lists?.length
              }`}
            </div>

            {tablePagination ? (
              <div className={Style.empDirectory_footer}>
                {tablePagination?.next_page_url ? (
                  <button
                    className={Style.loadMoreBtn}
                    onClick={() => {
                      if (btnLoader) return;
                      // setPageCount(pageCount + 1);
                      setBtnLoader(true);
                      // filterData({ page: pageCount + 1, btnCall: true });
                      getData({ page: tablePagination?.next_page_url });
                    }}
                  >
                    {btnLoader ? (
                      <InnerLoader
                        className={Style.loader}
                        textStatus={false}
                      />
                    ) : (
                      "Load More"
                    )}
                  </button>
                ) : null}
              </div>
            ) : null}

            <div
              className={`${Style.table_footer_left} ${Style.rightText}`}
            ></div>
          </div>
        ) : (
          <div className={Style.table_footer} style={{ alignItems: "center" }}>
            <div className={Style.table_footer_left}>
              <Skeleton width={"50%"} height={15} />
            </div>

            <div className={Style.empDirectory_footer}>
              <Skeleton width={"180px"} height={40} />
            </div>

            <div
              className={`${Style.table_footer_left} ${Style.rightText}`}
            ></div>
          </div>
        )}
      </div>

      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="get-van-damage-record-list"
        />
      )}

      {addModal && (
        <VanDamageModal
          cars={cars}
          damageData={currentData}
          onClose={() => {
            setAddModal(false);
            setCurrentData({});
          }}
          onError={onError}
          onSubmit={onSuccess}
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeaders}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeaders(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeaders(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="get-van-damage-record-list"
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default VanDamageList;